import React from 'react';
import { Card, Col } from 'react-bootstrap';
import CandidateProfile from './Profile/CandidateProfile';
import { Props } from './overview.type';

function Overview({ data }: Props) {
  return (
    data && (
      <Col md={6} xl={7} xxl={8} className="d-none d-md-block">
        <Card>
          <Card.Body>
            <CandidateProfile data={data} />
          </Card.Body>
        </Card>
      </Col>
    )
  );
}

export default Overview;
